import {storePayment, goCardLessCreatePayment, getPaypalClientId} from '@/api/payment'
import {mapGetters} from 'vuex'

export const PaypalMixin = {
  data () {
    return {
      paypal_client_id: null
    }
  },
  computed:{
    ...mapGetters(['get_go_card_course_id'])
  },
  mounted () {
    console.log(this.courseDetails)
    // setTimeout(() => {
    //   const script = document.createElement('script')
    //   script.src = 'https://www.paypal.com/sdk/js?currency=GBP&client-id=ATo98aPwA_aCJTVw63Fhf-m8J-EB8NzVwlbIDA-TiHLZQiHzP12mlEeOnDws-AZy9IizLwCdfeOX6qgn'
    //   script.addEventListener('load', this.setLoaded)
    //   document.body.appendChild(script)
    // }, 1000)
    
    
  },
  methods: {
    async getPaypalClientId (customer_id) {
      try {
        const response = await getPaypalClientId(customer_id)
        this.paypal_client_id = response.data.data.client_id
      } catch (e) {
        console.log(e)
      }
    },
    paypalInitiate () {
      setTimeout(() => {
        const script = document.createElement('script')
        script.src = `https://www.paypal.com/sdk/js?client-id=${this.paypal_client_id}`
        script.addEventListener('load', this.setLoaded)
        document.body.appendChild(script)
      }, 0)
    },
    setLoaded () {
    
      const vm = this
      setTimeout(() => {
        window.paypal
          .Buttons({
            style: {
              layout: 'horizontal',   
              size: 'responsive',
              color: 'blue',
              label: 'checkout',
              height: 38
            },
            createOrder:async (data, actions) => {
              
              let enrolledStatus = false
              if (this.courseDetails.isEnrolled) {
                enrolledStatus = true
              } else {
                enrolledStatus = await this.EnrolledCourse()

              }
              console.log(enrolledStatus)
              if (enrolledStatus) {
                return actions.order.create({
                  purchase_units:[
                    {
                      description:'Description part',
                      amount:{
                        currency_code:'GBP',
                        value:this.courseDetails.courseSetting.total_price
                      },
                      custom_id: this.courseDetails.id
                    }
                  ]
                })
              }
              //checkingEnrollmentDone
              
            },
            onApprove (data, actions) {
    
                
              console.log(data)
              console.log(vm)
              // This function captures the funds from the transaction.
              return actions.order.capture().then(function (details) {
                console.log(details)
                // This function shows a transaction success message to your buyer.
                // alert(`Transaction completed by ${  details.payer.name.given_name}`)
                // vm.showSuccessMessage('sucess',Your Payment is successfull')
                if (details) {
                  vm.savePayment(details)
                }
              })
            },
            onCancel (data, actions) {
              console.log(data)
              console.log(actions)
            }
          }).render(this.$refs.paypal)
      }, 1000)
      
    },
    async savePayment (paymentData) {
      this.$vs.loading({
        text:'Please do not refresh while payment is in progress'
      })
      try {
        const payload = {
          'jsonData':paymentData,
          'platform_module_id' :3,
          'platform_module':'Course',
          'entity_id': this.courseDetails.id,
          'amount':this.courseDetails.courseSetting.total_price,
          'currency_code':'GBP'
          //couse_id
        }
    
        const data = await storePayment(payload, this.courseDetails.platform_customer_id)
        this.courseDetails.isPaid = 1
        console.log(data)
        // this.EnrolledCourse()
    
      } catch (error) {
        console.log(error)

      } finally {
        this.$vs.loading.close()
      }
    },

    async goCardLessCheckEnrollment () {
      if (this.courseDetails.isEnrolled == 0) {
        const data = await this.EnrolledCourse()
        if (data) {
          this.goCardLessApi()
        }
      } else {
        this.goCardLessApi()
      }
    },
    
    async goCardLessApi () {
      try {
        const payload = {}
        console.log(this.courseDetails)
        if (this.courseDetails) {
          payload.course_id = this.courseDetails.id
          payload.platform_module_id = 3
          payload.platform_module = 'Course'
        }
        if (this.get_go_card_course_id) {
          payload.course_id = this.get_go_card_course_id.id
          payload.platform_module_id = 3
          payload.platform_module = 'Course'
        }
        console.log(payload)
        const {data} = await goCardLessCreatePayment(payload)
        
        console.log(data)
        if ('registration_status' in data.data && !data.data.registration_status) {
          this.SET_GO_CARD_COURSE_ID(this.courseDetails)
          console.log(data)
          this.openRegistrationPage(data.data.redirectFlowURL)
          this.$router.push({
            path: '/courses'
          })
        } else {
          this.courseDetails.isPaid = true
          this.$router.push({
            path: '/page/success'
          })
        }
      } catch (api_error) {

        if ('data' in api_error) {
          this.showSuccessMessage('Error', api_error.data.message, 'danger')
        }
        // console.log(api_error.data.message)
      }
    },
    openRegistrationPage (url) {
      console.log(url)
      window.open(url, '_blank')
      return false
      // window.open(url, '_blank')

    }
  }
}
